import listBeneficiariesTemplate from "./listBeneficiariesTemplate";

const listBeneficiaries = function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                beneficiaries: '=',
                designation: '@',
                model: '=',
                allocationChanged: '&',
                inCustomEnrollment: '=',
                qjsaVerificationRequired:'=',
                isViewOnly:'='
            },
            template: listBeneficiariesTemplate
        };
    };
export default listBeneficiaries;